module.exports = __webpack_public_path__ + "static/media/user.eb57bbb1.png";